import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this._autoTimer = setTimeout(() => this.dismiss(), this.timeoutValue)
    this._esc = (e) => { if (e.key === 'Escape') this.dismiss() }
    document.addEventListener('keydown', this._esc)
  }

  disconnect() {
    clearTimeout(this._autoTimer)
    document.removeEventListener('keydown', this._esc)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "translate-y-2")
    setTimeout(() => this.element.remove(), 250)
  }
}
